module.exports = __webpack_public_path__ + "static/media/navidad5.a966e67d.jpg";